import { render, staticRenderFns } from "./FAQNumber.vue?vue&type=template&id=3fbb0ad0&"
import script from "./FAQNumber.vue?vue&type=script&lang=js&"
export * from "./FAQNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports